const Vue = require('vue');

Vue.component('form-label', {
    props: {
        text: {
            type: String,
            default: null
        },
        hint: {
            type: String,
            default: null
        },
        hintClass: {
            type: String,
            default: null
        },
        hintIcon: {
            type: String,
            default: 'fa-question-circle'
        },
        for: {
            type: String,
            default: null
        }
    },
    data() {
        return {}
    },
    ready() {
    },
    template:`
            <label class="form-label">
                <slot>
                    {{ text }}
                </slot>
                <i v-if="hint" :class="[hintClass, hintIcon]" v-tooltip :vtitle="hint" class="fa"></i>
                <i v-if="required" v-tooltip title="Obrigatório" class="fa fa-exclamation-circle"></i>
            </label>
        `
});



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/form/label.js